import React from "react";
import logger from "logger";
import TaskDialog from "TaskDialogCommon/TaskDialog";
import RunButton from "TaskDialogCommon/RunButton";
import HeroNameSelector from "TaskDialogCommon/HeroNameSelector";
import TaskInput from "TaskDialogCommon/TaskInput";
import TaskCheckBox from "TaskDialogCommon/TaskCheckBox";
import errordialog from "Common/errordialog";
import { getLastConfigForTask } from "Utils/Common";

const taskname = "openschsmaps";

export default class Component extends React.Component {
  constructor(props) {
    super();
    const { accountdetailrow } = props;
    const initialState = {
      taskConfig: {
        accountdetail: accountdetailrow,
        atkheroname: "",
        unboxtroops: true,
        poprunesmins: 0,
      },
    };
    logger.log(`loading ${taskname} dialog`, props);
    this.loadStoredData(initialState, props);
    logger.log("initialState after load", initialState);
    this.state = initialState;
  }

  validate = () => {
    const {
      taskConfig: { atkheroname },
    } = this.state;
    if (!atkheroname || atkheroname.length === 0) {
      alert("Please select an attack hero before continuing");
      return false;
    }
    return true;
  };

  loadStoredData = (initialState, props) => {
    const { taskConfig } = initialState;
    try {
      const { AccountDetailData: accountdetail } = props;
      var storeddata = getLastConfigForTask(taskname);
      logger.log("storeddata", storeddata, accountdetail);
      if (storeddata) {
        for (var key in accountdetail.heroes) {
          var cityObj = accountdetail.heroes[key];
          for (var hkey in cityObj.cityheroes) {
            var heroObj = cityObj.cityheroes[hkey];
            if (heroObj.heroname === storeddata.atkheroname) {
              taskConfig.atkheroname = storeddata.atkheroname;
            }
          }
        }
        taskConfig.unboxtroops = storeddata.unboxtroops;
        taskConfig.poprunesmins = storeddata.poprunesmins;
      }
    } catch (e) {
      logger.log(e);
    }
  };

  setValue = (event, key) => {
    const value = event.target.value;
    this.setState((s, p) => ({
      taskConfig: { ...s.taskConfig, [key]: value },
    }));
  };

  render = () => {
    const {
      setValue,
      validate,
      state: { taskConfig },
      props: { AccountDetailData },
    } = this;
    if (AccountDetailData.heroes === undefined) {
      errordialog.showError(
        "Hero Data Not Found. Please refresh or contact administrator."
      );
      return null;
    }

    return (
      <TaskDialog heading={"Open SCHS Maps"}>
        <HeroNameSelector
          label={
            <>
              <span style={{ float: "left" }}>Attack Hero</span>
              <sup style={{ color: "red" }}>
                *Attack hero should NOT be in a city which has tactical troop
                city buffs enabled
              </sup>
            </>
          }
          AccountDetailData={AccountDetailData}
          taskConfig={taskConfig}
          setValue={setValue}
          param={"atkheroname"}
        />
        <TaskInput
          label={"Auto Pop 200% Runes for mins(Optional)"}
          value={taskConfig.poprunesmins}
          onChange={(event) => setValue(event, "poprunesmins")}
        />

        <TaskCheckBox
          label={"Auto Unbox Troops when needed."}
          param={"unboxtroops"}
          taskConfig={taskConfig}
          setValue={setValue}
        />

        <RunButton
          taskname={taskname}
          taskConfig={taskConfig}
          label={"Run SCHS Map Opener"}
          validate={validate}
        />
      </TaskDialog>
    );
  };
}
